// src/mobile-render.tsx
import React from "react";
import Empty from "./empty";
var mobileRender = props => {
  const {
    widgets,
    others = {},
    customFns = {}
  } = props;
  const {
    properties
  } = props.schema;
  return /* @__PURE__ */React.createElement("div", {
    style: props.style
  }, Object.keys(properties).map(key => {
    const {
      widget,
      containerType,
      ...rest
    } = properties[key];
    const Widget = widgets[widget];
    if (!Widget) return /* @__PURE__ */React.createElement(Empty, {
      key,
      widget
    });
    if (containerType && containerType === "template") {
      return /* @__PURE__ */React.createElement(Widget, {
        key,
        ...others,
        customFns,
        ...rest
      });
    }
    return /* @__PURE__ */React.createElement("div", {
      key
    }, "其他场景-待办");
  }));
};
var mobile_render_default = mobileRender;
export { mobile_render_default as default };